import { render, staticRenderFns } from "./shareRole.vue?vue&type=template&id=bac95aae"
import script from "./shareRole.vue?vue&type=script&lang=js"
export * from "./shareRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports